import React, { useEffect, useState } from 'react';
import api from '../api/client';
import { ricaricaVociPortale } from '../utils/vociPortale';

// Impostazioni → Ruoli: voci di menu dei portali Utenti e Allenatori, accese/spente come i permessi
// dei ruoli staff. Solo ROOT. Effetto immediato: menu e pagine spariscono, il server rifiuta le azioni.
const ETICHETTE = { UTENTE: 'UTENTE (clienti, soci)', ALLENATORE: 'ALLENATORE' };

export default function MatriceVociPortale() {
  const [dati, setDati] = useState(null);
  const [err, setErr] = useState('');
  const [salvando, setSalvando] = useState('');

  useEffect(() => { api.get('/funzionalita').then(r => setDati(r.data)).catch(e => setErr(e.response?.data?.error || 'Impossibile caricare le voci dei portali')); }, []);

  const cambia = async (portale, chiave, attiva) => {
    const k = portale + chiave; setSalvando(k); setErr('');
    try { const r = await api.put(`/funzionalita/${portale}/${chiave}`, { attiva }); setDati(r.data); ricaricaVociPortale(); }
    catch (e) { setErr(e.response?.data?.error || 'Errore nel salvataggio'); }
    finally { setSalvando(''); }
  };

  return (
    <div style={s.card}>
      <h2 style={s.titolo}>PORTALI UTENTI E ALLENATORI — VOCI DEL MENU</h2>
      <div style={s.help}>
        Togli la spunta per spegnere una voce: sparisce dal menu, la pagina mostra "non disponibile" e il server rifiuta le azioni collegate (ordini, prenotazioni campo, ticket, richiesta socio, rimborsi, documenti, presenze, conferma contratti). Utile quando una sezione non è pronta o non è in uso. "Cambia password" resta sempre disponibile. Ogni cambio finisce nel Changelog.
      </div>
      {err && <div style={s.err}>{err}</div>}
      {!dati ? <div style={s.help}>Caricamento…</div> : (
        <div style={{ overflowX: 'auto' }}>
          <table style={s.table}>
            <thead><tr>
              <th style={{ ...s.th, textAlign: 'left' }}>VOCE</th>
              {dati.portali.map(p => <th key={p} style={s.th}>{ETICHETTE[p] || p}</th>)}
            </tr></thead>
            <tbody>
              {dati.voci.map(v => (
                <tr key={v.chiave}>
                  <td style={s.td}>
                    <div style={{ fontWeight: 600, color: 'var(--text)' }}>{v.nome}</div>
                    {v.nota && <div style={{ fontSize: 'var(--font-size-xs)', color: 'var(--text-dim)' }}>{v.nota}</div>}
                  </td>
                  {dati.portali.map(p => {
                    if (!v.portali.includes(p)) return <td key={p} style={{ ...s.td, textAlign: 'center', color: 'var(--text-dim)' }}>—</td>;
                    const on = dati.stato?.[p]?.[v.chiave] !== false;
                    return (
                      <td key={p} style={{ ...s.td, textAlign: 'center' }}>
                        <input type="checkbox" checked={on} disabled={salvando === p + v.chiave} onChange={e => cambia(p, v.chiave, e.target.checked)}
                          aria-label={`${v.nome} per ${ETICHETTE[p]}`} style={{ width: '18px', height: '18px', accentColor: '#F4600C', cursor: 'pointer' }} />
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const s = {
  card: { background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: '12px', padding: '20px', marginTop: '24px' },
  titolo: { fontFamily: "'Barlow Condensed'", fontSize: 'var(--font-size-lg)', fontWeight: 700, letterSpacing: '2px', marginBottom: '8px', color: 'var(--text)' },
  help: { fontSize: 'var(--font-size-xs)', color: 'var(--text-dim)', marginBottom: '16px', maxWidth: '760px', lineHeight: 1.5 },
  err: { color: '#EF4444', fontSize: 'var(--font-size-sm)', marginBottom: '12px' },
  table: { borderCollapse: 'collapse', minWidth: '520px' },
  th: { fontSize: 'var(--font-size-xs)', letterSpacing: '1px', fontWeight: 700, color: 'var(--text-dim)', padding: '8px 16px', borderBottom: '1px solid var(--border)', textAlign: 'center' },
  td: { padding: '9px 16px', borderBottom: '1px solid var(--border)', fontSize: 'var(--font-size-sm)' },
};
